import React from 'react';
import { ReactComponent as IconSvg } from '@/images/icons/tag_close.svg';
const CloseIcon = (props) => React.createElement(IconSvg, Object.assign({}, props));
export default CloseIcon;
